import { createPortal } from 'react-dom';
import { prop } from 'ramda';
import { require } from 'js/backbone/portlets';
import { getCleanPath } from 'js/utils/url.util';
import { usePrevious } from 'js/hooks/usePrevious';
import React, { useRef, useEffect, useState } from 'react';
import { WebContent } from 'js/components/system/WebContent';
import { componentService } from 'js/services/component.service';
import { useDeviceSelector, useAppSelector } from 'js/store/hooks';
import { SLIDE_MENU_CLASS_NAME } from 'js/components/main/SlideMenu';
import { BackboneWrapper } from 'js/backbone/components/BackboneWrapper';

import * as hooks from './hooks';
import style from './DefaultMenu.scss';

const DefaultMenuWrapper = ({ slideMenuWcId = null }) => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const elRef = useRef();
    const [menuView, setMenuView] = useState(null);
    const backgroundPage = hooks.useGetBackgroundPage();
    const menuItems = useAppSelector(prop('menuItems'));
    const prevSlideMenuWcId = usePrevious(slideMenuWcId);
    const sportsbookRootURL = useAppSelector(prop('sportsbookRootURL'));
    const sportPageRegExp = new RegExp(`(^${sportsbookRootURL}$)|(^${sportsbookRootURL}/)`);
    const isBackgroundSportPage = sportPageRegExp.test(getCleanPath(backgroundPage));

    useEffect(() => {
        if (!menuItems || !menuItems.length || menuView) {
            return;
        }

        require(['modules_menu_menu_view'], (MenuView) => {
            const view = new MenuView({ el: elRef.current });

            setMenuView(view);
            view.setSlideMenuWcId(slideMenuWcId);
            view.render();
        });
    }, [setMenuView, menuItems, menuView, slideMenuWcId]);

    useEffect(() => () => menuView?.closeView(), [menuView]);

    useEffect(() => {
        if (isDesktop || !menuView || slideMenuWcId === prevSlideMenuWcId) {
            return;
        }

        menuView.setSlideMenuWcId(slideMenuWcId);
        menuView.render();
    }, [isDesktop, menuView, slideMenuWcId, prevSlideMenuWcId]);

    useEffect(() => {
        if (!menuView) {
            return;
        }

        if (sportsbookRootURL && isBackgroundSportPage) {
            menuView.activateMenu();
            menuView.setBackgroundPage();
        } else {
            menuView.activateMenu(backgroundPage);
            menuView.setBackgroundPage(backgroundPage);
        }
    }, [backgroundPage, isBackgroundSportPage, menuView, sportsbookRootURL]);

    if (isDesktop) {
        return <BackboneWrapper el={elRef} />;
    }

    const sliderContainer = document.querySelector(`.${SLIDE_MENU_CLASS_NAME}`);

    return sliderContainer
        ? createPortal(
            (
                <BackboneWrapper el={elRef}>
                    {slideMenuWcId && (
                        <div className={style.customSlideMenuWrapper}>
                            <div className={style.customSlideMenu}>
                                <WebContent id={slideMenuWcId} />
                            </div>
                        </div>
                    )}
                </BackboneWrapper>
        ), sliderContainer)
        : null;
};

export const DefaultMenu = ({ slideMenuWcId }) => <DefaultMenuWrapper slideMenuWcId={slideMenuWcId} />;

componentService.registerWebContentComponents({ DefaultMenu });
